/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const globe = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M1.14 6.6C1.048 7.052 1 7.52 1 8a6.987 6.987 0 0 0 2.644 5.48M1.14 6.6A7.002 7.002 0 0 1 13.6 3.8M1.14 6.6h3.331c.424 0 .803.296.906.707l.466 1.867a.944.944 0 0 1-.905 1.16h-.671l-.623 3.146m0 0A6.97 6.97 0 0 0 8 15a6.999 6.999 0 0 0 6.192-3.732M13.6 3.8A6.969 6.969 0 0 1 15 8a6.97 6.97 0 0 1-.808 3.268M13.6 3.8h-2.539a.942.942 0 0 0-.905.707L9.69 6.374a.944.944 0 0 0 .905 1.16h.983l.492 2.955c.074.444.47.78.92.78h1.202"
    />
  </svg>
)
export default globe
